<h2>Facility Details</h2>
<div *ngIf="facilitiesList.length > 0; else noFacilities">
  <mat-card class="facility-card">
    <mat-card-header>
      <mat-icon mat-card-avatar color="primary">check_circle</mat-icon>
      <mat-card-title>Facilities</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div *ngFor="let facility of facilitiesList" class="facility-details">
        <div class="facility-header">
          <span class="facility-name">Facility #{{ facility.facilityNumber }}</span>
          <span class="facility-status" *ngIf="facility.activeFlag === '1'">Active</span>
        </div>
        <p class="facility-id"><strong>Facility ID:</strong> {{ facility.facilityId }} ({{ facility.facilityNumber }})</p>
        <p><strong>Home Clinic:</strong> {{ facility.homeClinic ? 'Yes' : 'No' }}</p>
        <p class="facility-dates"><strong>From:</strong> {{ facility.fromDate | date: 'MM/dd/yyyy' }} | <strong>To:</strong> {{ facility.toDate ? (facility.toDate | date: 'MM/dd/yyyy') : 'Current' }}</p>
        <mat-divider></mat-divider>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #noFacilities>
  <div class="no-data-message">
    <mat-icon>info</mat-icon>
    <p>No facilities found for this patient.</p>
  </div>
</ng-template>
